module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bouncywrap"
  }, [_c('div', {
    staticClass: "dotcon dc1"
  }, [_c('div', {
    staticClass: "dot"
  })]), _c('div', {
    staticClass: "dotcon dc2"
  }, [_c('div', {
    staticClass: "dot"
  })]), _c('div', {
    staticClass: "dotcon dc3"
  }, [_c('div', {
    staticClass: "dot"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8322a5a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 125
// module chunks = 1